<div class="tooltip-container">
    <ng-content></ng-content> <!-- Aqui o conteúdo será injetado -->
    <div class="tooltip">       
        <div *ngIf="tipo === 'erro'" class="tooltip-icon">
            <img src="../../../assets/icons/error-warning-line.svg">                    
            <span class="tooltip-text error-text"><b>ERRO:</b></span> 
          </div>
        <ng-content select="[tooltip-text]"></ng-content>
    </div>
  </div>    